import React from 'react';
import { Link } from 'react-router-dom';
import './Keywords.css';

const Keywords = () => {
    const keywords = [
        { text: 'ونش انقاذ سيارات', link: '/services' },
        { text: 'ونش انقاذ 24 ساعة', link: '/services' },
        { text: 'سحب سيارات', link: '/services' },
        { text: 'شحن بطاريات', link: '/services' },
        { text: 'تغيير إطارات', link: '/services' },
        { text: 'توصيل وقود', link: '/services' },
        { text: 'ونش انقاذ سريع', link: '/' },
        { text: 'ونش انقاذ التجمع الخامس', link: '/areas/التجمع الخامس/' },
        { text: 'ونش انقاذ التجمع الاول', link: '/areas/التجمع الاول/' },
        { text: 'ونش انقاذ التجمع الثالث', link: '/areas/التجمع الثالث/' },
        { text: 'ونش انقاذ مدينه نصر', link: '/areas/مدينة نصر/' },
        { text: 'ونش انقاذ القطاميه', link: '/areas/القطاميه/' },
        { text: 'ونش انقاذ زهراء المعادي', link: '/areas/زهراء المعادي/' },
        { text: 'ونش انقاذ المعادي', link: '/areas/المعادي/' },
        { text: 'ونش انقاذ صقر قريش', link: '/areas/صقر قريش/' },
        { text: 'ونش انقاذ طريق السخنه', link: '/areas/طريق السخنه/' },
        { text: 'ونش انقاذ مصر الجديده', link: '/areas/مصر الجديده/' },
        { text: 'ونش انقاذ السلام', link: '/areas/السلام/' },
        { text: 'ونش انقاذ شيراتون', link: '/areas/شيراتون/' },
        { text: 'ونش انقاذ النزهه', link: '/areas/النزهه/' },
        { text: 'ونش انقاذ اكتوبر', link: '/areas/اكتوبر/' },
        { text: 'ونش انقاذ الشيخ زايد', link: '/areas/الشيخ زايد/' },
        { text: 'ونش انقاذ اسكندريه', link: '/areas/الإسكندرية/' },
        { text: 'ونش انقاذ العاصمه الاداريه', link: '/areas/العاصمة الإدارية/' },
        { text: 'ونش انقاذ العباسيه', link: '/areas/العباسية/' },
        { text: 'ونش انقاذ مدينتي', link: '/areas/مدينتي/' },
        { text: 'ونش انقاذ الرحاب', link: '/areas/الرحاب/' },
        { text: 'ونش انقاذ طريق السويس', link: '/areas/طريق السويس/' },
        { text: 'ونش انقاذ الساحل الشمالي', link: '/areas/الساحل الشمالي/' },
        { text: 'ونش انقاذ العبور', link: '/areas/العبور/' },
        { text: 'ونش انقاذ المقطم', link: '/areas/المقطم/' },
    ];

    return (
        <section className="keywords-section">
            <div className="keywords-container">
                <div className="keywords-header">
                    <h3 className="keywords-subtitle">ابحث عن خدماتنا</h3>
                    <h2 className="keywords-title">
                        كلمات <span className="highlight">بحث ذات صلة</span>
                    </h2>
                    <div className="keywords-divider">
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                    </div>
                </div>

                <div className="keywords-cloud">
                    {keywords.map((keyword, index) => (
                        <Link key={index} to={keyword.link} className="keyword-tag">
                            {keyword.text}
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Keywords;

